import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/keyboard-full/keyboard-full.js';
      import {ObcKeyboardFullType} from '@oicl/openbridge-webcomponents/dist/components/keyboard-full/keyboard-full.js';
import {ObcTextInputFieldSize} from '@oicl/openbridge-webcomponents/dist/components/text-input-field/text-input-field.js';

      export interface Props {
     type?: ObcKeyboardFullType;
     showTopBar?: boolean;
     parameterName?: string;
     value?: string;
     placeholder?: string;
     showNumberRow?: boolean;
     inputSize?: ObcTextInputFieldSize
   }

      
  
      export type {ObcKeyboardFullType} from '@oicl/openbridge-webcomponents/dist/components/keyboard-full/keyboard-full.js';
export type {ObcTextInputFieldSize} from '@oicl/openbridge-webcomponents/dist/components/text-input-field/text-input-field.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcKeyboardFull',
  props: {
    type: {},
    showTopBar: { type: Boolean },
    parameterName: {},
    value: {},
    placeholder: {},
    showNumberRow: { type: Boolean },
    inputSize: {}
  },
  emits: ["value-change", "done-click", "close-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onValueChange: (event: CustomEvent<{value: string}>) => emit('value-change', event as CustomEvent<{value: string}>),
onDoneClick: (event: CustomEvent<{value: string}>) => emit('done-click', event as CustomEvent<{value: string}>),
onCloseClick: (event: CustomEvent<void>) => emit('close-click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-keyboard-full',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})